import store from '@/store/index';
import en_US from '@/locales/en-US';
import es_MX from '@/locales/es-MX';

const Locales = {
  en_US,
  es_MX,
}

// 多语言函数
export function i18n (key = '') {
  if (!key) return '';
  const i18n = store.getState().setting.LocalesI18n;
  const locales = i18n ? Locales[i18n] : 'en_US';
  return locales[key] || '';
}
